<app-header></app-header>
<div class="container-fluid section">
    <div class="row justify-content-center">
        <div class="col-11 col-sm-10 sub-section d-flex flex-column">
            <div class="title mt-3">Reviews and rating</div>
            <div class="row mt-3" *ngIf="reviews.length && !loading">
                <div class="col-lg-5 col-xl-4 mb-3 divider">
                    <div class="d-flex flex-column">
                        <div class="text-center">
                            <circle-progress class="text-center" [backgroundPadding]="-2" [radius]="50"
                                [titleFontSize]="'25'" [percent]="progressPercent" [animation]="true"
                                [outerStrokeGradient]='true' [title]="progressTitle" [backgroundPadding]="10"
                                [showSubtitle]='false' [outerStrokeColor]="'#3FBD5B'" [titleFontWeight]="'600'"
                                [outerStrokeWidth]="6" [space]="-6" [innerStrokeWidth]="6"
                                [outerStrokeGradientStopColor]="'#3FBD5B'">
                            </circle-progress>
                        </div>
                        <div class="mb-4 review-rating-title text-center">based on {{midwife?.numReviews}} reviews
                            {{midwife.reviewSummary?.total}} ratings</div>
                        <div class="d-flex flex-column align-self-center">
                            <div class="d-flex flex-row mb-3">
                                <i class="fas fa-star mr-1 review-star"></i>
                                <div class="review-rating">5 </div>
                                <div class="progress">
                                    <div class="progress-bar" [ngClass]="progressBarCss(ratingProgressBar.rating5)"
                                        [style]="'width: '+ratingProgressBar.rating5+'%'" aria-valuenow="25"
                                        role="progressbar" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <div class="review-rating ml-2">{{midwife.reviewSummary?.rating5Count}}</div>
                            </div>
                            <div class="d-flex flex-row mb-3">
                                <i class="fas fa-star mr-1 review-star"></i>
                                <div class="review-rating">4 </div>
                                <div class="progress">
                                    <div class="progress-bar" [ngClass]="progressBarCss(ratingProgressBar.rating4)"
                                        role="progressbar" [style]="'width: '+ratingProgressBar.rating4+'%'"
                                        aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <div class="review-rating ml-2">{{midwife.reviewSummary?.rating4Count}}</div>
                            </div>
                            <div class="d-flex flex-row mb-3">
                                <i class="fas fa-star mr-1 review-star"></i>
                                <div class="review-rating">3 </div>
                                <div class="progress">
                                    <div class="progress-bar" [ngClass]="progressBarCss(ratingProgressBar.rating3)"
                                        role="progressbar" [style]="'width: '+ratingProgressBar.rating3+'%'"
                                        aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <div class="review-rating ml-2">{{midwife.reviewSummary?.rating3Count}}</div>
                            </div>
                            <div class="d-flex flex-row mb-3">
                                <i class="fas fa-star mr-1 review-star"></i>
                                <div class="review-rating">2 </div>
                                <div class="progress">
                                    <div class="progress-bar" [ngClass]="progressBarCss(ratingProgressBar.rating2)"
                                        role="progressbar" [style]="'width: '+ratingProgressBar.rating2+'%'"
                                        aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <div class="review-rating ml-2">{{midwife.reviewSummary?.rating2Count}}</div>
                            </div>
                            <div class="d-flex flex-row mb-3">
                                <i class="fas fa-star mr-1 review-star"></i>
                                <div class="review-rating">1&nbsp;</div>
                                <div class="progress">
                                    <div class="progress-bar" [ngClass]="progressBarCss(ratingProgressBar.rating1)"
                                        role="progressbar" [style]="'width: '+ratingProgressBar.rating1+'%'"
                                        aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <div class="review-rating ml-2">{{midwife.reviewSummary?.rating1Count}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-7 col-xl-8" *ngIf="reviews">
                    <div class="d-flex flex-row mb-3" *ngFor="let review of reviews; let i = index">
                        <img *ngIf="review.reviewerMum[0].profileImage" [src]="review.reviewerMum[0].profileImage"
                            alt="" class="profile-img mr-3">
                        <img *ngIf="!review.reviewerMum[0].profileImage" src="../../../../assets/Images/pro-pic.png"
                            alt="" class="profile-img mr-3">
                        <div class="d-flex flex-column flex-grow-1 pb-2"
                            [ngClass]="{'review-divider': i != reviews.length-1}">
                            <div class="d-flex flex-row justify-content-between mb-2">
                                <div class="d-flex flex-row">
                                    <div class="profile-name pt-1">{{review.reviewerMum[0]?.name}} </div>
                                    <span class="profile-chip ml-3 py-1 px-2">
                                        <i class="fas fa-star mr-1 star"></i>{{review?.rating}}
                                    </span>
                                </div>
                                <div class="date pt-1">{{review?.createdAt | date:'EEE dd MMM, yyyy'}}</div>
                            </div>
                            <div class="text-content">{{review?.reviewText}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row my-5" *ngIf="loading">
                <div class="spinner-border loader" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div class="no-data" *ngIf="!reviews.length && !loading">
                <img class="align-self-center" src="../../../../../assets/Images/NoDocuments.png" height="50" width="80"
                    alt="No Reviews">
                <span>No Reviews</span>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>